var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPt004ColorDiamond(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1002",
    "data-name": "Rectangle 1002",
    width: 31.945,
    height: 31.945,
    fill: "#1243e9"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "r_color_diamond",
    transform: "translate(-1732.5 -1700.417)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_987",
    "data-name": "Rectangle 987",
    transform: "translate(1732.5 1748.417) rotate(-45)",
    fill: "#e6ecff",
    stroke: "#093ce9",
    strokeWidth: 8
  }, /*#__PURE__*/React.createElement("rect", {
    width: 67.882,
    height: 67.882,
    rx: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 59.882,
    height: 59.882,
    rx: 4,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "storage_black_24dp",
    transform: "translate(1760.232 1728.232)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2310",
    "data-name": "Path 2310",
    d: "M0,0H39.931V39.931H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1734",
    "data-name": "Group 1734",
    transform: "translate(4.379 3.797)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1734-2",
    "data-name": "Group 1734"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2316",
    "data-name": "Path 2316",
    d: "M273.317,183.424c0-1.834-1.328-2.558-3.013-2.558a22.253,22.253,0,0,0-2.486.171V186.1l1.256.026c3.064.046,4.242-1.132,4.242-2.7",
    transform: "translate(-253.98 -171.52)",
    fill: "#1243e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2317",
    "data-name": "Path 2317",
    d: "M27.328,4.69a16.009,16.009,0,1,0,0,22.64,16.009,16.009,0,0,0,0-22.64m-4.1,17.777H20.572L16.18,15.884H13.839v5.235h2.289v1.349H10.367V21.118h1.979V9.517l-1.979-.243V8a9.4,9.4,0,0,0,2.217.289C13.813,8.288,15.069,8,16.3,8c2.387,0,4.6,1.085,4.6,3.736a3.9,3.9,0,0,1-3.137,3.907l3.721,5.478h1.736Z",
    transform: "translate(0 -0.001)",
    fill: "#1243e9"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPt004ColorDiamond);
export default __webpack_public_path__ + "static/media/PT004_color_diamond.be3900bae57a898b0eebbe79bd670c3c.svg";
export { ForwardRef as ReactComponent };